module.exports = __webpack_public_path__ + "img/ntw_logo_bw.cb7f6981.png";